import * as referenceTokens from './reference_tokens';

export const primary_50 = referenceTokens.nocturn_50;
export const primary_100 = referenceTokens.nocturn_100;
export const primary_200 = referenceTokens.nocturn_200;
export const primary_300 = referenceTokens.nocturn_300;
export const primary_400 = referenceTokens.nocturn_400;
export const primary_500 = referenceTokens.nocturn_500;
export const primary_600 = referenceTokens.nocturn_600;
export const primary_700 = referenceTokens.nocturn_700;
export const primary_800 = referenceTokens.nocturn_800;
export const primary_900 = referenceTokens.nocturn_900;
export const accent_50 = referenceTokens.cedar_50;
export const accent_100 = referenceTokens.cedar_100;
export const accent_200 = referenceTokens.cedar_200;
export const accent_300 = referenceTokens.cedar_300;
export const accent_400 = referenceTokens.cedar_400;
export const accent_500 = referenceTokens.cedar_500;
export const accent_600 = referenceTokens.cedar_600;
export const accent_700 = referenceTokens.cedar_700;
export const accent_800 = referenceTokens.cedar_800;
export const accent_900 = referenceTokens.cedar_900;
export const discovery_50 = referenceTokens.purple_50;
export const discovery_100 = referenceTokens.purple_100;
export const discovery_200 = referenceTokens.purple_200;
export const discovery_300 = referenceTokens.purple_300;
export const discovery_400 = referenceTokens.purple_400;
export const discovery_500 = referenceTokens.purple_500;
export const discovery_600 = referenceTokens.purple_600;
export const discovery_700 = referenceTokens.purple_700;
export const discovery_800 = referenceTokens.purple_800;
export const discovery_900 = referenceTokens.purple_900;
export const surfing_50 = referenceTokens.lake_50;
export const surfing_100 = referenceTokens.lake_100;
export const surfing_200 = referenceTokens.lake_200;
export const surfing_300 = referenceTokens.lake_300;
export const surfing_400 = referenceTokens.lake_400;
export const surfing_500 = referenceTokens.lake_500;
export const surfing_600 = referenceTokens.lake_600;
export const surfing_700 = referenceTokens.lake_700;
export const surfing_800 = referenceTokens.lake_800;
export const surfing_900 = referenceTokens.lake_900;
export const info_50 = referenceTokens.blue_50;
export const info_100 = referenceTokens.blue_100;
export const info_200 = referenceTokens.blue_200;
export const info_300 = referenceTokens.blue_300;
export const info_400 = referenceTokens.blue_400;
export const info_500 = referenceTokens.blue_500;
export const info_600 = referenceTokens.blue_600;
export const info_700 = referenceTokens.blue_700;
export const info_800 = referenceTokens.blue_800;
export const info_900 = referenceTokens.blue_900;
export const positive_50 = referenceTokens.green_50;
export const positive_100 = referenceTokens.green_100;
export const positive_200 = referenceTokens.green_200;
export const positive_300 = referenceTokens.green_300;
export const positive_400 = referenceTokens.green_400;
export const positive_500 = referenceTokens.green_500;
export const positive_600 = referenceTokens.green_600;
export const positive_700 = referenceTokens.green_700;
export const positive_800 = referenceTokens.green_800;
export const positive_900 = referenceTokens.green_900;
export const warning_50 = referenceTokens.yellow_50;
export const warning_100 = referenceTokens.yellow_100;
export const warning_200 = referenceTokens.yellow_200;
export const warning_300 = referenceTokens.yellow_300;
export const warning_400 = referenceTokens.yellow_400;
export const warning_500 = referenceTokens.yellow_500;
export const warning_600 = referenceTokens.yellow_600;
export const warning_700 = referenceTokens.yellow_700;
export const warning_800 = referenceTokens.yellow_800;
export const warning_900 = referenceTokens.yellow_900;
export const negative_50 = referenceTokens.red_50;
export const negative_100 = referenceTokens.red_100;
export const negative_200 = referenceTokens.red_200;
export const negative_300 = referenceTokens.red_300;
export const negative_400 = referenceTokens.red_400;
export const negative_500 = referenceTokens.red_500;
export const negative_600 = referenceTokens.red_600;
export const negative_700 = referenceTokens.red_700;
export const negative_800 = referenceTokens.red_800;
export const negative_900 = referenceTokens.red_900;
export const neutral_50 = referenceTokens.dark_grey_50;
export const neutral_100 = referenceTokens.dark_grey_100;
export const neutral_200 = referenceTokens.dark_grey_200;
export const neutral_300 = referenceTokens.dark_grey_300;
export const neutral_400 = referenceTokens.dark_grey_400;
export const neutral_500 = referenceTokens.dark_grey_500;
export const neutral_600 = referenceTokens.dark_grey_600;
export const neutral_700 = referenceTokens.dark_grey_700;
export const neutral_800 = referenceTokens.dark_grey_800;
export const neutral_900 = referenceTokens.dark_grey_900;
export const neutral_alt_50 = referenceTokens.grey_50;
export const neutral_alt_100 = referenceTokens.grey_100;
export const neutral_alt_200 = referenceTokens.grey_200;
export const neutral_alt_300 = referenceTokens.grey_300;
export const neutral_alt_400 = referenceTokens.grey_400;
export const neutral_alt_500 = referenceTokens.grey_500;
export const neutral_alt_600 = referenceTokens.grey_600;
export const neutral_alt_700 = referenceTokens.grey_700;
export const neutral_alt_800 = referenceTokens.grey_800;
export const neutral_alt_900 = referenceTokens.grey_900;
